export class Constants {

  public static ENCRYPT_KEY = 'pbBEDVymtG';

  public static countryLst() : KeyValuePair<string>[] {
    var countryLst: KeyValuePair<string>[] = [];
    countryLst.push({key: 'US', value: '(+1) United States'});
    countryLst.push({key: 'IN', value: '(+91) India'});
    countryLst.push({key: 'GB', value: '(+44) United Kingdom'});
    countryLst.push({key: 'GR', value: '(+30) Greece'});
    countryLst.push({key: 'PK', value: '(+92) Pakistan'});
    countryLst.push({key: 'NZ', value: '(+64) New Zealand'});
    countryLst.push({key: 'NP', value: '(+977) Nepal'});
    countryLst.push({key: 'NL', value: '(+31) Netherlands'});
    countryLst.push({key: 'MM', value: '(+95) Myanmar'});
    countryLst.push({key: 'MX', value: '(+52) Mexico'});
    countryLst.push({key: 'MY', value: '(+60) Malaysia'});
    countryLst.push({key: 'IT', value: '(+39) Italy'});
    countryLst.push({key: 'IE', value: '(+353) Ireland'});
    countryLst.push({key: 'HK', value: '(+852) Hong Kong'});
    countryLst.push({key: 'DE', value: '(+49) Germany'});
    countryLst.push({key: 'FR', value: '(+33) France'});
    countryLst.push({key: 'CN', value: '(+86) China'});
    countryLst.push({key: 'BR', value: '(+55) Brazil'});
    countryLst.push({key: 'AU', value: '(+61) Australia'});
    countryLst.push({key: 'AL', value: '(+355) Albania'});
    countryLst.push({key: 'DZ', value: '(+213) Algeria'});
    countryLst.push({key: 'AD', value: '(+376) Andorra'});
    countryLst.push({key: 'AO', value: '(+244) Angola'});
    countryLst.push({key: 'AR', value: '(+54) Argentina'});
    countryLst.push({key: 'AM', value: '(+374) Armenia'});
    countryLst.push({key: 'AW', value: '(+297) Aruba'});
    countryLst.push({key: 'AT', value: '(+43) Austria'});
    countryLst.push({key: 'AZ', value: '(+994) Azerbaijan'});
    countryLst.push({key: 'BH', value: '(+973) Bahrain'});
    countryLst.push({key: 'BD', value: '(+880) Bangladesh'});
    countryLst.push({key: 'BE', value: '(+32) Belgium'});
    countryLst.push({key: 'BZ', value: '(+501) Belize'});
    countryLst.push({key: 'BJ', value: '(+229) Benin'});
    countryLst.push({key: 'BO', value: '(+591) Bolivia'});
    countryLst.push({key: 'BA', value: '(+387) Bosnia and Herzegovina'});
    countryLst.push({key: 'BW', value: '(+267) Botswana'});
    countryLst.push({key: 'BN', value: '(+673) Brunei'});
    countryLst.push({key: 'BG', value: '(+359) Bulgaria'});
    countryLst.push({key: 'BF', value: '(+226) Burkina Faso'});
    countryLst.push({key: 'BI', value: '(+257) Burundi'});
    countryLst.push({key: 'KH', value: '(+855) Cambodia'});
    countryLst.push({key: 'CM', value: '(+237) Cameroon'});
    countryLst.push({key: 'CA', value: '(+1) Canada'});
    countryLst.push({key: 'CV', value: '(+238) Cape Verde'});
    countryLst.push({key: 'CF', value: '(+236) Central African Republic'});
    countryLst.push({key: 'TD', value: '(+235) Chad'});
    countryLst.push({key: 'CL', value: '(+56) Chile'});
    countryLst.push({key: 'CO', value: '(+57) Colombia'});
    countryLst.push({key: 'KM', value: '(+269) Comoros'});
    countryLst.push({key: 'CK', value: '(+682) Cook Islands'});
    countryLst.push({key: 'CR', value: '(+506) Costa Rica'});
    countryLst.push({key: 'HR', value: '(+385) Croatia'});
    countryLst.push({key: 'CY', value: '(+357) Cyprus'});
    countryLst.push({key: 'CZ', value: '(+420) Czech Republic'});
    countryLst.push({key: 'DK', value: '(+45) Denmark'});
    countryLst.push({key: 'DJ', value: '(+253) Djibouti'});
    countryLst.push({key: 'EC', value: '(+593) Ecuador'});
    countryLst.push({key: 'EG', value: '(+20) Egypt'});
    countryLst.push({key: 'SV', value: '(+503) El Salvador'});
    countryLst.push({key: 'GQ', value: '(+240) Equatorial Guinea'});
    countryLst.push({key: 'EE', value: '(+372) Estonia'});
    countryLst.push({key: 'ET', value: '(+251) Ethiopia'});
    countryLst.push({key: 'FO', value: '(+298) Faroe Islands'});
    countryLst.push({key: 'FJ', value: '(+679) Fiji'});
    countryLst.push({key: 'FI', value: '(+358) Finland'});
    countryLst.push({key: 'GF', value: '(+594) French Guiana'});
    countryLst.push({key: 'GA', value: '(+241) Gabon'});
    countryLst.push({key: 'GM', value: '(+220) Gambia'});
    countryLst.push({key: 'GE', value: '(+995) Georgia'});
    countryLst.push({key: 'GH', value: '(+233) Ghana'});
    countryLst.push({key: 'GI', value: '(+350) Gibraltar'});
    countryLst.push({key: 'GL', value: '(+299) Greenland'});
    countryLst.push({key: 'GP', value: '(+590) Guadeloupe'});
    countryLst.push({key: 'GT', value: '(+502) Guatemala'});
    countryLst.push({key: 'GN', value: '(+224) Guinea'});
    countryLst.push({key: 'GW', value: '(+245) Guinea-Bissau'});
    countryLst.push({key: 'GY', value: '(+592) Guyana'});
    countryLst.push({key: 'HT', value: '(+509) Haiti'});
    countryLst.push({key: 'HN', value: '(+504) Honduras'});
    countryLst.push({key: 'HU', value: '(+36) Hungary'});
    countryLst.push({key: 'IS', value: '(+354) Iceland'});
    countryLst.push({key: 'ID', value: '(+62) Indonesia'});
    countryLst.push({key: 'IL', value: '(+972) Israel'});
    countryLst.push({key: 'JP', value: '(+81) Japan'});
    countryLst.push({key: 'JO', value: '(+962) Jordan'});
    countryLst.push({key: 'KE', value: '(+254) Kenya'});
    countryLst.push({key: 'KI', value: '(+686) Kiribati'});
    countryLst.push({key: 'KW', value: '(+965) Kuwait'});
    countryLst.push({key: 'KG', value: '(+996) Kyrgyzstan'});
    countryLst.push({key: 'LA', value: '(+856) Laos'});
    countryLst.push({key: 'LV', value: '(+371) Latvia'});
    countryLst.push({key: 'LB', value: '(+961) Lebanon'});
    countryLst.push({key: 'LS', value: '(+266) Lesotho'});
    countryLst.push({key: 'LY', value: '(+218) Libya'});
    countryLst.push({key: 'LI', value: '(+423) Liechtenstein'});
    countryLst.push({key: 'LT', value: '(+370) Lithuania'});
    countryLst.push({key: 'LU', value: '(+352) Luxembourg'});
    countryLst.push({key: 'MO', value: '(+853) Macau'});
    countryLst.push({key: 'MK', value: '(+389) Macedonia'});
    countryLst.push({key: 'MG', value: '(+261) Madagascar'});
    countryLst.push({key: 'MW', value: '(+265) Malawi'});
    countryLst.push({key: 'MV', value: '(+960) Maldives'});
    countryLst.push({key: 'ML', value: '(+223) Mali'});
    countryLst.push({key: 'MT', value: '(+356) Malta'});
    countryLst.push({key: 'MQ', value: '(+596) Martinique'});
    countryLst.push({key: 'MR', value: '(+222) Mauritania'});
    countryLst.push({key: 'MU', value: '(+230) Mauritius'});
    countryLst.push({key: 'MD', value: '(+373) Moldova'});
    countryLst.push({key: 'MC', value: '(+377) Monaco'});
    countryLst.push({key: 'MO', value: '(+976) Mongolia'});
    countryLst.push({key: 'ME', value: '(+382) Montenegro'});
    countryLst.push({key: 'MA', value: '(+212) Morocco'});
    countryLst.push({key: 'MZ', value: '(+258) Mozambique'});
    countryLst.push({key: 'NA', value: '(+264) Namibia'});
    countryLst.push({key: 'AN', value: '(+599) Netherlands Antilles'});
    countryLst.push({key: 'NC', value: '(+687) New Caledonia'});
    countryLst.push({key: 'NI', value: '(+505) Nicaragua'});
    countryLst.push({key: 'NE', value: '(+227) Niger'});
    countryLst.push({key: 'NG', value: '(+234) Nigeria'});
    countryLst.push({key: 'NO', value: '(+47) Norway'});
    countryLst.push({key: 'OM', value: '(+968) Oman'});
    countryLst.push({key: 'PW', value: '(+680) Palau'});
    countryLst.push({key: 'PS', value: '(+970) Palestinian Territory'});
    countryLst.push({key: 'PA', value: '(+507) Panama'});
    countryLst.push({key: 'PG', value: '(+675) Papua New Guinea'});
    countryLst.push({key: 'PY', value: '(+595) Paraguay'});
    countryLst.push({key: 'PE', value: '(+51) Peru'});
    countryLst.push({key: 'PH', value: '(+63) Philippines'});
    countryLst.push({key: 'PL', value: '(+48) Poland'});
    countryLst.push({key: 'PT', value: '(+351) Portugal'});
    countryLst.push({key: 'QA', value: '(+974) Qatar'});
    countryLst.push({key: 'RE', value: '(+262) Reunion Island'});
    countryLst.push({key: 'RO', value: '(+40) Romania'});
    countryLst.push({key: 'RU', value: '(+7) Russia'});
    countryLst.push({key: 'RW', value: '(+250) Rwanda'});
    countryLst.push({key: 'WS', value: '(+685) Samoa'});
    countryLst.push({key: 'ST', value: '(+239) Sao Tome and Principe'});
    countryLst.push({key: 'SA', value: '(+966) Saudi Arabia'});
    countryLst.push({key: 'SN', value: '(+221) Senegal'});
    countryLst.push({key: 'RS', value: '(+381) Serbia'});
    countryLst.push({key: 'SC', value: '(+248) Seychelles'});
    countryLst.push({key: 'SL', value: '(+232) Sierra Leone'});
    countryLst.push({key: 'SG', value: '(+65) Singapore'});
    countryLst.push({key: 'SK', value: '(+421) Slovakia'});
    countryLst.push({key: 'SI', value: '(+386) Slovenia'});
    countryLst.push({key: 'SB', value: '(+677) Solomon Islands'});
    countryLst.push({key: 'SO', value: '(+252) Somalia'});
    countryLst.push({key: 'ZA', value: '(+27) South Africa'});
    countryLst.push({key: 'KR', value: '(+) South Korea'});
    countryLst.push({key: 'ES', value: '(+34) Spain'});
    countryLst.push({key: 'LK', value: '(+94) Sri Lanka'});
    countryLst.push({key: 'SR', value: '(+597) Suriname'});
    countryLst.push({key: 'SZ', value: '(+268) Swaziland'});
    countryLst.push({key: 'SE', value: '(+46) Sweden'});
    countryLst.push({key: 'CH', value: '(+41) Switzerland'});
    countryLst.push({key: 'TW', value: '(+886) Taiwan'});
    countryLst.push({key: 'TJ', value: '(+992) Tajikistan'});
    countryLst.push({key: 'TZ', value: '(+255) Tanzania'});
    countryLst.push({key: 'TH', value: '(+66) Thailand'});
    countryLst.push({key: 'TG', value: '(+228) Togo'});
    countryLst.push({key: 'TO', value: '(+676) Tonga'});
    countryLst.push({key: 'TN', value: '(+216) Tunisia'});
    countryLst.push({key: 'TR', value: '(+90) Turkey'});
    countryLst.push({key: 'TM', value: '(+993) Turkmenistan'});
    countryLst.push({key: 'UG', value: '(+256) Uganda'});
    countryLst.push({key: 'UA', value: '(+380) Ukraine'});
    countryLst.push({key: 'AE', value: '(+971) United Arab Emirates'});
    countryLst.push({key: 'UY', value: '(+598) Uruguay'});
    countryLst.push({key: 'UZ', value: '(+998) Uzbekistan'});
    countryLst.push({key: 'VU', value: '(+678) Vanuatu'});
    countryLst.push({key: 'VE', value: '(+58) Venezuela'});
    countryLst.push({key: 'YE', value: '(+967) Yemen'});
    countryLst.push({key: 'ZM', value: '(+260) Zambia'});
    return countryLst;
  }

}
